import { useMutation } from '@tanstack/react-query'
import type { FundingNeedDataAssessmentResponse } from '@/models/FundingNeeds'
import { serverURL } from '../api/config'

async function assessFundingNeed(
  token: string,
  needId: number
): Promise<FundingNeedDataAssessmentResponse> {
  const response = await fetch(
    `${serverURL}/funding-needs/${needId}/assess`,
    {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
    }
  )
  if (!response.ok) throw new Error('Failed to assess funding need')
  return response.json()
}

export function useAssessFundingNeed() {
  return useMutation({
    mutationFn: ({
      token,
      needId,
    }: {
      token: string
      needId: number
    }) => assessFundingNeed(token, needId),
  })
}
